import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataPaymentMethod } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_PAYMENT_METHOD = defineMasterdataEntity<MasterdataPaymentMethod>({
  name: 'payment-method',
  responseKey: 'paymentMethods',
  displayWith: (p) => keyName(p.key, p.name),
  secondaryWith: (p) => p.usage?.name ?? null,
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-credit-card',
  title: 'Zahlungsartsuche',
  label: 'Zahlungsart',
  placeholder: 'Zahlungsart suchen...',
  columns: [
    {
      label: 'Zahlungsart',
      type: 'entity',
      icon: 'fa-regular fa-credit-card',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) => e.usage?.name ?? null,
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'Verwendung', type: 'text', value: (e) => e.usage?.name ?? null },
    { label: 'Aktiv', type: 'text', value: (e) => (e.active ? 'Ja' : 'Nein') },
  ],
});
